import { Alert } from "react-bootstrap"
import "./VerifyEmail.css"


const VerifyEmail = (props) => {
    return (<div className="verifyEmail">
        <Alert variant={'success'}>
            <Alert.Heading>Verify email</Alert.Heading>
            <hr />
            <p>An email has been sent to {props.email}.</p>
            <p>Please follow the provided link to verify your email and complete the registration within 24 hours.</p>
            <p>Make sure to check the spam folder.</p>
            You can now close this window
        </Alert>
    </div>)
}

export default VerifyEmail
